import React from "react";
import PropTypes from "prop-types";
import Checkbox from "@mui/material/Checkbox";

export default function PrimaryCheckbox({checked, handleChange, value, color, disabled}) {
  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      value={value}
      disabled={disabled}
      sx={{
        padding: "0px",
        color: color || "black_opacity.70",
        "&:hover": {
          backgroundColor: "transparent"
        },
        "&.Mui-checked": {
          color: color || "primary.60"
        },
        "&.Mui-disabled": {
          color: "black_opacity.20",
          "&.Mui-checked": {
            color: "black_opacity.30"
          },
        },
      }}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
}

PrimaryCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  color: PropTypes.string,
  disabled: PropTypes.bool
};